import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import PageSection from '../../../../features/components/PageSection'
import Button from '../../../../components/Button'
import ShortPostRightCreate from '../../../../forms/Multiplatform/Partnerships/RightForms/SpecificRightForms/ShortPostRightCreate'

import useStyles from '../styles'

const ReportsSection = ({ goToCampaignHubButtonHandler }) => {
  const classes = useStyles()

  return (
    <PageSection className={classes.section}>
      <h3 className={classes.sectionTitle}>View or download a report</h3>
      <div className={classnames(classes.subSectionsContainer, classes.reportsSubSectionContainer)}>
        <div className={classes.subSection}>
          <h4 className={classes.sectionSubTitle}>Organic social post reporting</h4>
          <p>
            Automatically generate organic social post reach and engagement reports from Facebook, Instagram and Twitter
            using partner brand keywords.
          </p>
          <ShortPostRightCreate openBtnClassName={classes.actionButton} />
        </div>
        <div className={classes.subSection}>
          <h4 className={classes.sectionSubTitle}>Campaign reporting</h4>
          <p>Campaign reporting can be generated from the campaign hub.</p>
          <Button onClick={goToCampaignHubButtonHandler} className={classes.actionButton}>
            Go to campaign hub
          </Button>
        </div>
      </div>
    </PageSection>
  )
}

ReportsSection.propTypes = {
  goToCampaignHubButtonHandler: PropTypes.func.isRequired
}

export default ReportsSection
